module.exports = __webpack_public_path__ + "img/elo-payment-link.4a0bdb8e.svg";